import gql from 'graphql-tag';

export default gql`
query getPagePreviewSlug($pageId: Int!) {
  pages_by_pk(page_id: $pageId) {
    page_id
    preview_slug
  }
}
`;
